import { GetCompletedSurveysGeneralResponseDTO } from '@/core/dto/psychosocial-report';
import type { GetCompletedSurveysGeneralResponse } from '@/types/Psychosocial';

export class GetCompletedSurveysGeneralMapper {
	constructor(private readonly data: GetCompletedSurveysGeneralResponseDTO) {}

	private readonly RISK_CATEGORY_MAP = {
		mental_result: 'Temporal demand',
		physical_result: 'Physical demand',
		temporal_result: 'Temporal demand',
		effort_result: 'Effort level',
		frustration_result: 'Frustration level',
		performance_result: 'Achievement level',
		control: 'ControlV2',
		change: 'ChangeV2',
		relationship: 'Relationship',
		management_support: 'Management Support',
		colleagues_support: 'Colleagues Support',
		duty: 'Duty'
	};

	private mapRiskCategory(risk_category: string): string {
		return this.RISK_CATEGORY_MAP[risk_category as keyof typeof this.RISK_CATEGORY_MAP] || risk_category;
	}

	toDomain(): GetCompletedSurveysGeneralResponse {
		return {
			rows: this.data.rows.map((row) => ({
				...row,
				risk_category: this.mapRiskCategory(row.risk_category!)
			})),
			count: this.data.count
		};
	}
}
